import { UpdateCmSheetCertificateOfCertificationsRequest } from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetCertificateOfCertificationsService = {
  async get(cmSheetId: number, certificationId: number): Promise<ArrayBuffer> {
    const response = await httpClient.get<ArrayBuffer>(
      `v1/cm-sheets/${cmSheetId}/certifications/${certificationId}/certificate`,
      { responseType: "arraybuffer" },
    );

    return response;
  },
  async update(
    cmSheetId: number,
    certificationId: number,
    body: UpdateCmSheetCertificateOfCertificationsRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/cm-sheets/${cmSheetId}/certifications/${certificationId}/certificate`,
      body,
      { contentType: "multipart/form-data" },
    );
  },
  async delete(cmSheetId: number, certificationId: number): Promise<void> {
    await httpClient.delete(
      `v1/cm-sheets/${cmSheetId}/certifications/${certificationId}/certificate`,
    );
  },
};

export default CmSheetCertificateOfCertificationsService;
